var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationBellActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3742 15.9366L18.4361 17.95H1.84163L3.9036 15.9366L4.12963 15.7159V15.4V8.8C4.12963 5.91911 6.27816 3.49937 9.13447 3.02799L9.76235 2.92437V2.288V1.1C9.76235 1.01302 9.79756 0.925887 9.86627 0.858796C9.93559 0.791113 10.0333 0.75 10.1389 0.75C10.2444 0.75 10.3422 0.791113 10.4115 0.858796L10.9343 0.323427L10.4115 0.858797C10.4802 0.925887 10.5154 1.01302 10.5154 1.1V2.288V2.92437L11.1433 3.02799C13.9996 3.49937 16.1481 5.91911 16.1481 8.8V15.4V15.7159L16.3742 15.9366ZM11.4252 20.55C11.3647 20.6466 11.2921 20.737 11.2081 20.819C10.9275 21.093 10.5432 21.25 10.1389 21.25C9.73455 21.25 9.35027 21.093 9.06969 20.819C8.98572 20.737 8.91308 20.6466 8.85254 20.55H11.4252Z",
    fill: "#F1FA29",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellActive);
export default __webpack_public_path__ + "static/media/notificationBellActive.ae87d70c81308a001e1d0740e6da239b.svg";
export { ForwardRef as ReactComponent };